// Product page interactions
(function() {
  // Thumbnail gallery
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-thumb-index]');
    if (!thumb) return;

    const mainImage = document.querySelector('[data-main-image]');
    if (!mainImage) return;

    mainImage.removeAttribute('srcset');
    mainImage.src = thumb.dataset.imageUrl;

    document.querySelectorAll('.product-gallery__thumb').forEach(t => {
      t.classList.remove('product-gallery__thumb--active');
    });
    thumb.classList.add('product-gallery__thumb--active');
  });

  // Quantity selector
  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-quantity-minus]');
    const plus = e.target.closest('[data-quantity-plus]');
    const input = document.querySelector('[data-quantity-input]');
    if (!input) return;

    if (minus) {
      const val = parseInt(input.value, 10);
      if (val > 1) input.value = val - 1;
    }
    if (plus) {
      input.value = parseInt(input.value, 10) + 1;
    }
  });

  // Variant selection
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    const productId = productForm.dataset.productId;

    // Mark unavailable swatches from inline variant data
    function markUnavailableSwatches(variants) {
      productForm.querySelectorAll('.product-option__swatch').forEach(function(swatch) {
        var radio = swatch.querySelector('input[type="radio"]');
        if (!radio) return;
        var optionName = radio.name;
        var optionValue = radio.value;
        // Find if any variant with this option value is available
        var hasAvailable = variants.some(function(v) {
          return (v.option1 === optionValue || v.option2 === optionValue || v.option3 === optionValue) && v.available;
        });
        swatch.classList.toggle('product-option__swatch--unavailable', !hasAvailable);
      });
    }

    // Initial mark from embedded JSON
    var inlineData = document.querySelector('[data-product-variants]');
    if (inlineData) {
      try { markUnavailableSwatches(JSON.parse(inlineData.textContent)); } catch(e) {}
    }

    productForm.addEventListener('change', (e) => {
      if (!e.target.closest('[data-option-input]')) return;

      // Build selected options
      const options = [];
      productForm.querySelectorAll('[data-option-input]').forEach(input => {
        if (input.type === 'radio') {
          if (input.checked) options.push(input.value);
        } else {
          options.push(input.value);
        }
      });

      // Immediately update swatch active states (visual feedback before fetch)
      productForm.querySelectorAll('.product-option__swatch').forEach(s => {
        const radio = s.querySelector('input[type="radio"]');
        s.classList.toggle('product-option__swatch--active', radio && radio.checked);
      });

      // Fetch variant data (.js endpoint returns available + featured_image)
      var handle = window.location.pathname.split('/').pop();
      fetch('/products/' + handle + '.js')
        .then(res => res.json())
        .then(data => {
          const variant = data.variants.find(v => {
            return v.option1 === options[0] &&
              (options.length < 2 || v.option2 === options[1]) &&
              (options.length < 3 || v.option3 === options[2]);
          });

          if (!variant) return;

          // Update swatch availability indicators
          markUnavailableSwatches(data.variants);

          // Update hidden variant ID
          const variantInput = productForm.querySelector('[data-variant-id]');
          if (variantInput) variantInput.value = variant.id;

          // Update price
          const priceEl = document.querySelector('[data-product-price]');
          if (priceEl) {
            const price = variant.price / 100;
            const comparePrice = variant.compare_at_price ? variant.compare_at_price / 100 : 0;
            if (comparePrice && comparePrice > price) {
              priceEl.innerHTML = '<s class="product-info__price--compare">\u00a3' + comparePrice.toFixed(2) + '</s> <span class="product-info__price--sale">\u00a3' + price.toFixed(2) + '</span>';
            } else {
              priceEl.innerHTML = '<span>\u00a3' + price.toFixed(2) + '</span>';
            }
          }

          // Update add to cart button
          const addBtn = productForm.querySelector('[data-add-to-cart]');
          if (addBtn) {
            addBtn.disabled = !variant.available;
            addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
          }

          // Update stock status text
          const stockEl = document.querySelector('[data-stock-status]');
          if (stockEl) {
            stockEl.textContent = variant.available ? 'In Stock' : 'Out of Stock';
            stockEl.className = variant.available
              ? 'product-info__stock product-info__stock--in'
              : 'product-info__stock product-info__stock--out';
          }

          // Show/hide quantity selector based on availability
          var qtySelector = productForm.querySelector('.quantity-selector');
          if (qtySelector) {
            qtySelector.style.display = variant.available ? '' : 'none';
          }

          // Update main image if variant has one
          if (variant.featured_image) {
            var mainImage = document.querySelector('[data-main-image]');
            if (mainImage) {
              mainImage.removeAttribute('srcset');
              mainImage.src = variant.featured_image.src;
            }
            // Highlight matching thumbnail by image ID
            var matchThumb = document.querySelector('[data-image-id="' + variant.featured_image.id + '"]');
            if (matchThumb) {
              document.querySelectorAll('.product-gallery__thumb').forEach(function(t) {
                t.classList.remove('product-gallery__thumb--active');
              });
              matchThumb.classList.add('product-gallery__thumb--active');
            }
          }

          // Update URL
          const url = new URL(window.location);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        });
    });
  }
})();
